class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    const isMobileForm = facetForm && facetForm.id === 'FacetFiltersFormMobile';

    if (isMobileForm) {
      // Prevent checkboxes from triggering any drawer close behavior
      facetForm.addEventListener('input', (event) => {
        if (event.target.classList.contains('mobile-facets__checkbox')) {
          event.stopPropagation();
          this.updateMobileApplyButtons(facetForm);
        }
      });

      facetForm.addEventListener(
        'click',
        (event) => {
          if (event.target.classList.contains('mobile-facets__checkbox')) {
            event.stopPropagation();
          }
        },
        true
      );

      facetForm.addEventListener('submit', (event) => this.onSubmitHandler(event));
    } else {
      this.updateApplyButton(facetForm);
      if (facetForm.classList.contains('facets__form-vertical')) {
        facetForm.addEventListener('input', () => {
          this.updateApplyButton(facetForm);
        });
        facetForm.addEventListener('submit', (event) => this.onSubmitHandler(event));
      } else {
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      }
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    const isMobileSubmit = event && event.target && event.target.id === 'FacetFiltersFormMobile';

    setTimeout(() => {
      const drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
      if (drawer) {
        FacetFiltersForm.setupMobileFacetsOverlayClick(drawer);
      } else {
        console.warn('[FacetFiltersForm] ERROR: Drawer not found!');
      }
    }, 2000);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.updateApplyButtonAfterRender();
        if (typeof initializeScrollAnimationTrigger === 'function') {
          try {
            initializeScrollAnimationTrigger();
          } catch (e) {
            console.error('[FacetFiltersForm] initializeScrollAnimationTrigger error', e);
          }
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.updateApplyButtonAfterRender();
    if (typeof initializeScrollAnimationTrigger === 'function') {
      try {
        initializeScrollAnimationTrigger();
      } catch (e) {
        console.error('[FacetFiltersForm] initializeScrollAnimationTrigger error', e);
      }
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const fetchedProductCount = parsedHTML.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    let countNumber = null;
    if (fetchedProductCount) {
      const fetchedDesktopSpan = fetchedProductCount.querySelector('.product-count-desktop');
      if (fetchedDesktopSpan) {
        const desktopText = fetchedDesktopSpan.textContent.trim();
        const match = desktopText.match(/\b(\d+)\b/);
        if (match) {
          countNumber = match[1];
        }
      }
    }

    // Update all ProductCount elements in the DOM (there may be multiple instances)
    const allProductCountElements = document.querySelectorAll('#ProductCount');
    allProductCountElements.forEach((container) => {
      if (fetchedProductCount) {
        // Update the container with the full innerHTML from fetched HTML
        container.innerHTML = fetchedProductCount.innerHTML;

        // Update the data-count attribute on the desktop span for mobile CSS styling
        const desktopSpan = container.querySelector('.product-count-desktop');
        if (desktopSpan && countNumber) {
          desktopSpan.setAttribute('data-count', countNumber);
        }

        container.classList.remove('loading');
      }
    });

    if (containerDesktop) {
      const fetchedProductCountDesktop = parsedHTML.getElementById('ProductCountDesktop');
      if (fetchedProductCountDesktop) {
        containerDesktop.innerHTML = fetchedProductCountDesktop.innerHTML;
      } else if (fetchedProductCount) {
        const desktopSpan = fetchedProductCount.querySelector('.product-count-desktop');
        if (desktopSpan) {
          containerDesktop.innerHTML = desktopSpan.innerHTML;
        }
      }
      containerDesktop.classList.remove('loading');
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement && elementToRender.parentElement.id) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;

      const activeFacetsInWrapper = activeFacetsElement.closest('#FacetsWrapperDesktop');
      if (activeFacetsInWrapper) {
        const wrapperDesktop = document.querySelector('#FacetsWrapperDesktop');
        if (wrapperDesktop) {
          const existingActiveFacets = wrapperDesktop.querySelector(selector);
          if (existingActiveFacets) {
            existingActiveFacets.innerHTML = activeFacetsElement.innerHTML;
          }
        }
      } else {
        const existingActiveFacets = document.querySelector(selector);
        if (existingActiveFacets) {
          existingActiveFacets.innerHTML = activeFacetsElement.innerHTML;
        }
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }

    const targetSummary = target.querySelector('.mobile-facets__summary');
    const sourceSummary = source.querySelector('.mobile-facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id
      }
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });

    if (isMobile) {
      const drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
      if (drawer) {
        const summary = drawer.querySelector('summary');
        const mainDetails = drawer.querySelector('details');

        if (summary && mainDetails && mainDetails.hasAttribute('open')) {
          summary.click();
        }
      }
    }
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  updateApplyButton(form) {
    const submitButton = form.querySelector('button[type="submit"]');
    const checkedOptions = form.querySelectorAll('input[type="checkbox"]:checked');

    if (!submitButton) return;

    if (checkedOptions.length > 0) {
      submitButton.innerText = `Apply (${checkedOptions.length})`;
    } else {
      submitButton.innerText = `Apply`;
    }
  }

  updateMobileApplyButtons(form) {
    const checkedOptions = form.querySelectorAll('input.mobile-facets__checkbox:checked');
    const applyButtons = form.querySelectorAll('button.button--primary[type="submit"]');

    applyButtons.forEach((button) => {
      if (checkedOptions.length > 0) {
        button.innerText = `Apply (${checkedOptions.length})`;
      } else {
        button.innerText = `Apply`;
      }
    });
  }

  static updateApplyButtonAfterRender() {
    const facetForm = document.querySelector('#FacetFiltersForm.facets__form-vertical');
    if (facetForm) {
      const facetFiltersFormElement = facetForm.closest('facet-filters-form');
      if (facetFiltersFormElement) {
        facetFiltersFormElement.updateApplyButton(facetForm);
      }
    }

    const mobileForm = document.querySelector('#FacetFiltersFormMobile');
    if (mobileForm) {
      const mobileFacetsFormElement = mobileForm.closest('facet-filters-form');
      if (mobileFacetsFormElement) {
        mobileFacetsFormElement.updateMobileApplyButtons(mobileForm);
      }
    }
  }

  static updateDataCountAttribute() {
    requestAnimationFrame(() => {
      const allProductCountElements = document.querySelectorAll('#ProductCount');

      allProductCountElements.forEach((container) => {
        const desktopSpan = container.querySelector('.product-count-desktop');

        if (desktopSpan) {
          const desktopText = desktopSpan.textContent.trim();
          const desktopMatch = desktopText.match(/\b(\d+)\b/);

          if (desktopMatch) {
            const desktopCount = desktopMatch[1];
            desktopSpan.setAttribute('data-count', desktopCount);
          }
        }
      });
    });
  }

  static setupMobileFacetsOverlayClick(drawer) {
    if (drawer.dataset.mobileOverlayInitialized === 'true') {
      return;
    }
    drawer.dataset.mobileOverlayInitialized = 'true';

    const mobileFacets = drawer.querySelector('.mobile-facets');
    const mobileFacetsMain = drawer.querySelector('.mobile-facets__main');
    const summary = drawer.querySelector('summary');
    const details = drawer.querySelector('details');

    if (mobileFacets && mobileFacetsMain && summary && details) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (details.hasAttribute('open')) {
              mobileFacets.style.pointerEvents = 'auto';
            } else {
              mobileFacets.style.pointerEvents = 'none';
            }
          }
        });
      });

      observer.observe(details, {
        attributes: true,
        attributeFilter: ['open']
      });

      if (details.hasAttribute('open')) {
        mobileFacets.style.pointerEvents = 'auto';
      } else {
        mobileFacets.style.pointerEvents = 'none';
      }

      mobileFacets.addEventListener('click', (event) => {
        if (
          event.target === mobileFacets ||
          (event.target.closest('.mobile-facets') === mobileFacets && !mobileFacetsMain.contains(event.target))
        ) {
          if (details.hasAttribute('open')) {
            event.preventDefault();
            event.stopPropagation();
            summary.click();
          }
        }
      });
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

const initializeMobileFacets = () => {
  FacetFiltersForm.updateDataCountAttribute();

  const drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
  if (drawer) {
    FacetFiltersForm.setupMobileFacetsOverlayClick(drawer);
  }

  const mobileForm = document.querySelector('#FacetFiltersFormMobile');
  if (mobileForm) {
    const mobileFacetsFormElement = mobileForm.closest('facet-filters-form');
    if (mobileFacetsFormElement) {
      mobileFacetsFormElement.updateMobileApplyButtons(mobileForm);
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMobileFacets);
} else {
  initializeMobileFacets();
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
